import { NewsApiResponse, NewsItem } from "../types/news";

const API_BASE_URL = 'https://api.eon.health/blog/api/news/';

export const newsService = {
  // Fetch all news items with optional page parameter
  async getAllNews(page: number = 1): Promise<NewsApiResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}?page=${page}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching news:', error);
      throw error;
    }
  },

  // Fetch a single news item by slug
  async getNewsBySlug(slug: string): Promise<NewsItem | null> {
    try {
      const response = await fetch(`${API_BASE_URL}${slug}/`);
      if (!response.ok) {
        if (response.status === 404) {
          return null;
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching news item:', error);
      throw error;
    }
  }
};
